
    
        var maquetteH = require('maquette').h;
        var h = function(selector, props, children) {
          var attributes = Object.assign({}, props.attributes || {}, props);
          delete attributes["attributes"];

          // This should be done by pug-vdom, oh well...
          if (attributes.class) {
            selector += "." + attributes.class.trim().split(/ +/).join(".");
            delete attributes["class"];
          }

          return maquetteH(selector, attributes, children);
        }
      ;
    function render(context, h, text = (string) => string) {
  if (!pugVDOMRuntime) throw "pug-vdom runtime not found.";
  var runtime = pugVDOMRuntime
  var locals = context;
  var self = locals;
  var remainingKeys = pugVDOMRuntime.enterLocalsScope(locals);
  for (var prop in remainingKeys) {
    eval('var ' + prop + ' =  locals.' + prop);
  }
  var n0Child = []
  var n178Child = []
  var n179Child = []
  var n180Child = []
  var n181Child = []
  var n182Child = []
  n182Child = n182Child.concat(text(this.label))
  var props = {attributes: runtime.compileAttrs([], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n182 = h('h2', props, n182Child)
  n181Child.push(n182)
  if(!(this.initial)) {
    var n183Child = []
    n183Child = n183Child.concat(text(this.trigger._name || this.t('.untitled')))
    var props = {attributes: runtime.compileAttrs([], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n183 = h('p', props, n183Child)
    n181Child.push(n183)
  }
  var props = {attributes: runtime.compileAttrs([], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n181 = h('div', props, n181Child)
  n180Child.push(n181)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'card-header-title'},{name:'class', val: 'trigger-editor-title'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n180 = h('div', props, n180Child)
  n179Child.push(n180)
  if(!(this.initial)) {
    var n184Child = []
    var n185Child = []
    var n186Child = []
    var n187Child = []
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'far'},{name:'class', val: 'fa-trash-alt'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n187 = h('i', props, n187Child)
    n186Child.push(n187)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'icon'},{name:'class', val: 'is-small'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n186 = h('span', props, n186Child)
    n185Child.push(n186)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'button'},{name:'class', val: 'is-small'},{name:'class', val: 'is-danger'},{name:'class', val: 'is-light'},{name:'type', val: "button"},{name:'onclick', val: this.deleteTrigger},{name:'title', val: this.t('.delete_trigger_title')}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n185 = h('button', props, n185Child)
    n184Child.push(n185)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'card-header-icon'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n184 = h('div', props, n184Child)
    n179Child.push(n184)
  }
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'card-header'},{name:'class', val: 'trigger-editor-card-header'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n179 = h('header', props, n179Child)
  n178Child.push(n179)
  var n188Child = []
  if(this.trigger.type != "_initial") {
    var n189Child = []
    if(this.conditionEditor) {
      n189Child = n189Child.concat(text(this.conditionEditor.render()))
    } else {
      var n190Child = []
      n190Child = n190Child.concat(text(this.t('.unsupported_condition') + this.trigger.type))
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'unsupported-condition'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n190 = h('p', props, n190Child)
      n189Child.push(n190)
    }
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'box'},{name:'class', val: 'trigger-condition'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n189 = h('section', props, n189Child)
    n188Child.push(n189)
  }
  var n191Child = []
  var v192 = this.configuredActions
  Object.keys(v192).forEach(function (k193) {
    var menuEntry = v192[k193]
    var n194Child = []
    var n195Child = []
    var n196Child = []
    var n197Child = []
    var n198Child = []
    n198Child = n198Child.concat(text(menuEntry.label))
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'action-type'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n198 = h('span', props, n198Child)
    n197Child.push(n198)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'level-item'},{name:'class', val: 'trigger-action-title'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n197 = h('div', props, n197Child)
    n196Child.push(n197)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'level-left'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n196 = h('div', props, n196Child)
    n195Child.push(n196)
    var n199Child = []
    var n200Child = []
    var n201Child = []
    var n202Child = []
    var n203Child = []
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'far'},{name:'class', val: 'fa-trash-alt'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n203 = h('i', props, n203Child)
    n202Child.push(n203)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'icon'},{name:'class', val: 'is-small'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n202 = h('span', props, n202Child)
    n201Child.push(n202)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'button'},{name:'class', val: 'is-small'},{name:'class', val: 'is-danger'},{name:'class', val: 'is-light'},{name:'type', val: "button"},{name:'onclick', val: this.deleteAction.bind(this, menuEntry.type)},{name:'title', val: this.t('.delete_action_title')}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n201 = h('button', props, n201Child)
    n200Child.push(n201)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'level-item'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n200 = h('div', props, n200Child)
    n199Child.push(n200)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'level-right'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n199 = h('div', props, n199Child)
    n195Child.push(n199)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'level'},{name:'class', val: 'is-mobile'},{name:'class', val: 'trigger-action-header'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n195 = h('header', props, n195Child)
    n194Child.push(n195)
    var n204Child = []
    if(menuEntry.unsupported) {
      var n205Child = []
      n205Child = n205Child.concat(text(this.t('.unsupported_action_note')))
      var props = {attributes: runtime.compileAttrs([], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n205 = h('p', props, n205Child)
      n204Child.push(n205)
    } else {
      actionEditor = this.actionEditorFor(menuEntry.type)
      if(actionEditor) {
        n204Child = n204Child.concat(text(actionEditor.render()))
      }
    }
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'trigger-action-body'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n204 = h('div', props, n204Child)
    n194Child.push(n204)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'trigger-action'},{name:'class', val: 'box'},{name:'class', val: hyphenize(menuEntry.type)},{name:'classes', val: {unsupported: menuEntry.unsupported}},{name:'key', val: menuEntry.type}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n194 = h('div', props, n194Child)
    n191Child.push(n194)
  }.bind(this))
  var n206Child = []
  var v207 = this.availableActions
  Object.keys(v207).forEach(function (k208) {
    var menuEntry = v207[k208]
    var n209Child = []
    var n210Child = []
    var n211Child = []
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'fas'},{name:'class', val: menuEntry.icon}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n211 = h('i', props, n211Child)
    n210Child.push(n211)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'icon'},{name:'class', val: 'is-small'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n210 = h('span', props, n210Child)
    n209Child.push(n210)
    var n212Child = []
    n212Child = n212Child.concat(text(menuEntry.label))
    var props = {attributes: runtime.compileAttrs([], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n212 = h('span', props, n212Child)
    n209Child.push(n212)
    if(menuEntry.conflict) {
      conflictLabel = this.constructor.ACTIONS[menuEntry.conflict].label
      var n213Child = []
      n213Child = n213Child.concat(text(` (${this.t('.incompatible', {label: conflictLabel})})`))
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'conflict-label'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n213 = h('span', props, n213Child)
      n209Child.push(n213)
    }
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'button'},{name:'class', val: 'is-light'},{name:'class', val: 'is-fullwidth'},{name:'class', val: 'is-justify-content-flex-start'},{name:'type', val: "button"},{name:'key', val: menuEntry.type},{name:'disabled', val: menuEntry.conflict},{name:'onclick', val: (menuEntry.conflict ? null : this.addAction.bind(this, menuEntry))}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n209 = h('button', props, n209Child)
    n206Child.push(n209)
  }.bind(this))
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'buttons'},{name:'class', val: 'is-flex-direction-column'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n206 = h('div', props, n206Child)
  n191Child.push(n206)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'trigger-actions'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n191 = h('section', props, n191Child)
  n188Child.push(n191)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'card-content'},{name:'class', val: 'trigger-editor-body'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n188 = h('div', props, n188Child)
  n178Child.push(n188)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'trigger-editor-card'},{name:'class', val: 'card'},{name:'classes', val: {"is-initial": this.initial}},{name:'key', val: this},{name:'afterCreate', val: this.bindElement},{name:'afterUpdate', val: this.bindElement}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n178 = h('div', props, n178Child)
  n0Child.push(n178)
  pugVDOMRuntime.exitLocalsScope()
  return n0Child
}
;
    module.exports = function(locals) {
      locals = Object.assign(window.DEFAULT_TEMPLATE_LOCALS || {}, locals || {});
      return render.call(this, locals, h);
    };
  